import React, { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { AdminHeader, AdminPage } from "@/components/admin/AdminUI";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit?limit=200").then(({ data }) => setLogs(data)).catch(() => {}); }, []);
  return (
    <>
      <AdminHeader title="Audit Logs" subtitle="Secure activity trail" />
      <AdminPage>
        <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200"><tr className="text-left text-[11px] uppercase tracking-wider text-slate-500">
              <th className="px-4 py-3">Action</th><th className="px-4 py-3">Entity</th><th className="px-4 py-3">User</th><th className="px-4 py-3">Change</th><th className="px-4 py-3">Time</th>
            </tr></thead>
            <tbody>
              {logs.length === 0 ? <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-400">No activity recorded.</td></tr>
                : logs.map((l) => (
                  <tr key={l.id} className="border-b border-slate-100">
                    <td className="px-4 py-3"><span className="font-mono text-xs bg-slate-100 px-2 py-0.5 rounded">{l.action}</span></td>
                    <td className="px-4 py-3 text-slate-500 text-xs">{l.entity} {l.details?.title ? `· ${l.details.title.slice(0, 30)}` : ""}</td>
                    <td className="px-4 py-3 text-slate-600">{l.user_name}</td>
                    <td className="px-4 py-3 text-xs text-slate-500">{l.old_value && l.new_value ? `${l.old_value} → ${l.new_value}` : "—"}</td>
                    <td className="px-4 py-3 text-xs font-mono text-slate-400">{l.created_at?.replace("T", " ").slice(0, 16)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </AdminPage>
    </>
  );
}
